import WeightInputLabel from './WeightInputLabel';

export default WeightInputLabel;
